<template>
  <v-select
    @input="
      (event) => {
        emitChange(event);
      }
    "
    v-model="selectedItem"
    :items="items"
    item-text="text"
    item-value="value"
    :label="$t('message.filter_month')"
    clearable
    outlined
    dense
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      selectedItem: null,
      items: null,
    };
  },
  props: ["value"],
  created() {
    this.getLast12Months();
  },
  watch: {
    value: {
      immediate: true,
      handler: function(newValue) {
        this.selectedItem = newValue;
      },
    },
    selectedItem: {
      immediate: true,
      handler: function(newValue) {
        if (newValue) {
          //console.log(newValue);
          //console.log(new Date(newValue));
        }
      },
    },
  },
  methods: {
    getLast12Months() {
      var d = new Date();
      var months = [];
      try {
        months.push({
          text: this.$d(d, "month_year", this.$i18n.locale),
          value: d.getTime(),
        });
        for (var i = 0; i < 11; i++) {
          d.setMonth(d.getMonth() - 1);
          months.push({
            text: this.$d(d, "month_year", this.$i18n.locale),
            value: d.getTime(),
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.items = months;
    },
    emitChange(event) {
      this.$emit("input", event);
    },
  },
};
</script>

<style scoped></style>
